export default {
    methods: {
        commaFormat(x) {
            if (x != null) {
                var parts = x.toString().split(".");
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                // if (x % 1 == 0) return `${parts}.00`
                // else
                return parts.join(".");
            }
        },
        currencyFormat(x) {
            if(x != null && x != undefined && x != ''){
                x = Number(x); // Convert to number if it's string
                return x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else {
                return '0.00';
            }
        },
        sortVariants(row, log) {
            row.sort((a, b) =>
                String(a?.opt1 || "").localeCompare(
                String(b?.opt1 || ""),
                undefined,
                { numeric: true, sensitivity: "base" }
                )
            );
            if (log) {
                const inStock = row.filter(r => Number(r?.available_stock) > 0);
                const outOfStock = row.filter(r => Number(r?.available_stock) <= 0);
                return [...inStock, ...outOfStock];
            }

            return row;
        },

    }
}